// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__ulE-L","rootSmall":"AddTileButton_rootSmall__2lxOx"};